// extracted by mini-css-extract-plugin
export default {"groupForm":"CreateBalance_groupForm__Rdt9R","fieldSet":"CreateBalance_fieldSet__6DQEQ"};